import { Empty, Form } from 'antd';
import { Row, Spin } from 'antd';
import { debounce } from 'lodash';
import { useCallback, useEffect, useMemo } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import accountApis from '../../../../../services/accountApis';
import { AutoComplete } from 'antd';
import { CustomerType } from '../../../../../services/apisType';

const SearchCustomers = () => {
  const [optionsAutoComplete, setOptionsAutoComplete] = useState<
    { value: string; label: string }[]
  >([]);

  const form = Form.useFormInstance();
  const { id } = useParams();
  const [filterOptions, setFilterOptions] = useState<{ value: string; label: string }[]>([]);
  const [textSearch, setTextSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const addCustomerIfNotExists = (data: any, option: any): void => {
    const parts = option.label.split(' - ');
    const customer: CustomerType = {
      customerId: '',
      customerName: parts[0], // Assuming the name is in the label property of the option
      customerPhone: parts[1], // Assuming the phone is in the value property of the option
      email: parts[2], // Assuming point is a property of the option, adjust accordingly
      birthday: parts[3],
      point: parts[4],
      lastVisitedDate: parts[5],
      amountSpent: parts[6],
    };

    const lstCustomer = form.getFieldValue('customers');
    if (!lstCustomer.some((c: CustomerType) => c.customerPhone === customer.customerPhone)) {
      // Nếu số điện thoại chưa tồn tại, thêm customer vào mảng
      form.setFieldsValue({ customers: [...lstCustomer, customer] });
    } else {
      // Nếu số điện thoại đã tồn tại, có thể xử lý theo mong muốn của bạn, ví dụ: thông báo lỗi
      console.error(`Customer with phone ${customer.customerPhone} already exists.`);
    }
  };

  const getList = useCallback(
    debounce(async (value: string) => {
      setTextSearch(value);
      try {
        const response = await accountApis.simpleSearchCustomers(id || '', value);

        if (response.status === 200) {
          const res = response.data.data.content.map((item: any) => ({
            value: item.phone, // Assuming item has a property called 'value'
            label: `${item.name} - ${item.phone} - ${item.email}`,
          }));
          setFilterOptions(res);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }, 500),
    []
  );

  const options = useMemo(() => {
    if (!textSearch) return optionsAutoComplete;
    return filterOptions;
  }, [textSearch, optionsAutoComplete, filterOptions]);

  const getListCustomer = debounce(async () => {
    try {
      const response = await accountApis.simpleSearchCustomers(id || '', '');
      if (response.status === 200) {
        const res = response.data.data.content.map((item: any) => ({
          value: item.phone, // Assuming item has a property called 'value'
          label: `${item.name} - ${item.phone} - ${item.email}`,
        }));
        setOptionsAutoComplete(res);
      } else {
        setOptionsAutoComplete([]);
      }
    } catch (error) {
      setOptionsAutoComplete([]);
    }
  }, 500);

  useEffect(() => {
    getListCustomer();
  }, []);

  return (
    <AutoComplete
      style={{ width: '100%' }}
      size='large'
      placeholder='Customer Phone/ Email'
      options={options}
      onSelect={(a, b) => {
        setTextSearch('');
        addCustomerIfNotExists(a, b);
      }}
      dropdownRender={(menu) => (
        <>
          {textSearch && loading ? (
            <Row align={'middle'} justify={'center'}>
              <div style={{ padding: '1.5rem 0' }}>
                <Spin />
              </div>
            </Row>
          ) : (
            menu
          )}
        </>
      )}
      notFoundContent={<Empty />}
      value={textSearch}
      onSearch={(text) => {
        if (text) setLoading(true);
        setTextSearch(text);
        getList(text);
      }}
    />
  );
};

export default SearchCustomers;
